var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleRounded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85749 8.57084C6.46909 9.21818 5.53091 9.21818 5.14251 8.57084L0.908698 1.5145C0.508783 0.847972 0.988895 -8.9471e-09 1.76619 5.90062e-08L10.2338 7.99269e-07C11.0111 8.67222e-07 11.4912 0.847972 11.0913 1.5145L6.85749 8.57084Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTriangleRounded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/triangle-rounded.1b3f33b51c2995e72025a67bc1c52d02.svg";